import { FC } from 'react';

import { Link } from 'dibs-elements/exports/Link';
import { FormattedMessage } from 'dibs-react-intl';
import getBuyerSupportLink from 'dibs-support-link/exports/getBuyerSupportLink';

import {
    isOPOPMessagingABTest,
    isControlOPOPMessagingABTest,
    isVariantOneMessagingABTest,
} from '../../ContactDealerModal/helpers/contactDealer';

export const SafePurchaseReminderMessage: FC = () => {
    const policyLink = (
        <Link href={getBuyerSupportLink('/en-us/articles/14516223858587/')} target="_blank">
            {isControlOPOPMessagingABTest() || !isOPOPMessagingABTest() ? (
                <FormattedMessage
                    id="dbl.SafePurchaseReminderMessage.ourPolicy"
                    defaultMessage="our policy"
                />
            ) : (
                <FormattedMessage
                    id="dbl.SafePurchaseReminderMessage.details"
                    defaultMessage="Details"
                />
            )}
        </Link>
    );

    if (isControlOPOPMessagingABTest() || !isOPOPMessagingABTest()) {
        return (
            <FormattedMessage
                id="dbl.SafePurchaseReminderMessage.buyerPolicyMessage"
                defaultMessage="Sharing contact information to purchase outside of 1stDibs is against {policyLink}."
                values={{ policyLink }}
            />
        );
    }

    return isVariantOneMessagingABTest() ? (
        <FormattedMessage
            id="dbl.SafePurchaseReminderMessage.accountSuspensionWarning"
            defaultMessage="Don’t exchange contact information to buy outside of 1stDibs, which could lead to an account suspension. {policyLink}"
            values={{
                policyLink,
            }}
        />
    ) : (
        <FormattedMessage
            id="dbl.SafePurchaseReminderMessage.policyViolation"
            defaultMessage="Don’t exchange contact information to buy outside of 1stDibs, which is against our policy. {policyLink}"
            values={{
                policyLink,
            }}
        />
    );
};
